import {z} from 'zod';

import {useHelpLinks} from '../../provider/help-links/help-links-hook';
import {useUser} from '../../provider/user/user-hook';

import {HelpLinkFeatureFlagEnum} from './feature-flag-const';

const helpLinkFeatureFlagConfigSchema = z.object({
    available: z.boolean(),
    availableForStaff: z.boolean(),
    users: z.array(z.number()).optional(),
});

export function useFeatureFlag(flag: HelpLinkFeatureFlagEnum): boolean {
    const helpLinks = useHelpLinks();
    const {user} = useUser();

    const flagLink = helpLinks.find((link) => link.urlPattern === flag);

    if (!flagLink) {
        return false;
    }

    const configResult = helpLinkFeatureFlagConfigSchema.safeParse(flagLink.config);

    if (!configResult.success) {
        return false;
    }

    const {available, availableForStaff, users} = configResult.data;

    if (available) {
        return true;
    }

    if (availableForStaff && user?.isStaff) {
        return true;
    }

    return Boolean(user && users?.includes(user.id));
}
